import { t } from 'i18next'
import React from 'react'

import {
  StyledModalContent,
  StyledCancelButton,
  StyledEnrollButton,
  StyledHeaderText,
  StyledSuggestionText,
  StyledButtonContainer
} from './PatientEnrollModal.styles'
import { ClinTheme } from '../../../../ClinTheme'
import { ClinModal } from '../../../../components/ClinModal'
import { PTA_ENROLMENT_RESTRICTED_MESSAGE } from '../../patientInitialsDisplay'

interface IPatientEnrollModalProps {
  isOpen: boolean
  handleEnroll: () => void
  handleClose: () => void
  /**
   * CLOS-13391 - When true, the patient belongs to an exPTA program
   * (`programStatus === Post Trial Access Only`) and the HCP is not
   * yet enrolled. PTA enrolment is controlled by the Program Manager
   * via direct request, so the Enrol CTA must NOT be offered. The
   * modal still opens (so the user understands why the patient row
   * action did nothing) but only shows a Cancel button.
   */
  isPtaRestricted?: boolean
}

export const PatientEnrollModal: React.FC<IPatientEnrollModalProps> = ({
  isOpen,
  handleEnroll,
  handleClose,
  isPtaRestricted = false
}) => {
  return (
    <ClinModal
      isOpen={isOpen}
      onClose={handleClose}
      maxWidth="xs"
      height="auto"
      padding={`${ClinTheme.space[5]}px`}
      borderRadius="4px"
    >
      <StyledModalContent>
        {isPtaRestricted ? (
          <StyledSuggestionText as="div" style={{ textAlign: 'center' }}>
            {PTA_ENROLMENT_RESTRICTED_MESSAGE}
          </StyledSuggestionText>
        ) : (
          <>
            <StyledHeaderText as="div">
              {t('patient_detail:patient_enroll_modal.modal_title')}
            </StyledHeaderText>
            <StyledSuggestionText as="div">
              {t('patient_detail:patient_enroll_modal.modal_description')}
            </StyledSuggestionText>
          </>
        )}
        <StyledButtonContainer>
          <StyledCancelButton
            variant="purpleSecondaryNarrow"
            onClick={handleClose}
          >
            {t('patient_detail:patient_enroll_modal.cancel_button_text')}
          </StyledCancelButton>
          {!isPtaRestricted && (
            <StyledEnrollButton variant="purpleNarrow" onClick={handleEnroll}>
              {t('patient_detail:patient_enroll_modal.enroll_button_text')}
            </StyledEnrollButton>
          )}
        </StyledButtonContainer>
      </StyledModalContent>
    </ClinModal>
  )
}
